<!-- <div class="close-icon" (click)="closeDialog()">
  <mat-icon aria-hidden="false" aria-label="close">close</mat-icon>
</div> -->

<mat-dialog-content #dialogContent class="mg-dialog-content">
  <ng-container
    [cdkPortalOutlet]="contentPortal"
    (attached)="handleContentAttached($event)"
  ></ng-container>
</mat-dialog-content>
